export const MAP = "/s";
export const OVERVIEW = "/";
export const LISTINGS = "/listings";
export const CHARGERS = "/chargers";
export const CHARGES = "/charges";
export const REPORTS = "/reports";
export const SESSIONS = "/reports/sessions"
export const REPORTS_ID = "/reports/:id";
